import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionLabel = ({ children, light = false }) => (
  <div className="flex items-center gap-3 mb-5" data-testid="section-label">
    <span className="h-px w-10 bg-brand-red" />
    <span className={`font-mono text-[11px] uppercase tracking-[0.28em] ${light ? "text-white/80" : "text-brand-red"}`}>
      {children}
    </span>
  </div>
);
